import { cva } from 'cva';
export const popoverVariant = cva({
    base: [
        '@z-50',
        '@rounded-lg',
        '@shadow-down6',
        '@bg-grey-1',
        '@text-grey-6',
        '@px-4',
        '@py-3',
    ],
    variants: {
        animation: {
            true: [
                '@animate-in',
                '@fade-in-0',
                '@zoom-in-95',
                'data-[state=closed]:@animate-out',
                'data-[state=closed]:@fade-out-0',
                'data-[state=closed]:@zoom-out-95',
                'data-[side=bottom]:@slide-in-from-top-2',
                'data-[side=left]:@slide-in-from-right-2',
                'data-[side=right]:@slide-in-from-left-2',
                'data-[side=top]:@slide-in-from-bottom-2'
            ]
        }
    },
    defaultVariants: { animation: true }
});
